import { NumberExt } from '../../util';
import { Rectangle } from '../../geometry';
export function getPointBBox(p) {
  return new Rectangle(p.x, p.y, 0, 0);
}
export function getPaddingBox() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const sides = NumberExt.normalizeSides(options.padding || 20);
  return {
    x: -sides.left,
    y: -sides.top,
    width: sides.left + sides.right,
    height: sides.top + sides.bottom
  };
}
export function getSourceBBox(view) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return view.sourceBBox.clone().moveAndExpand(getPaddingBox(options));
}
export function getTargetBBox(view) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return view.targetBBox.clone().moveAndExpand(getPaddingBox(options));
}
export function getSourceAnchor(view) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (view.sourceAnchor) {
    return view.sourceAnchor;
  }
  const bbox = getSourceBBox(view, options);
  return bbox.getCenter();
}
export function getTargetAnchor(view) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (view.targetAnchor) {
    return view.targetAnchor;
  }
  const bbox = getTargetBBox(view, options);
  return bbox.getCenter();
}